// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import AccountSettingsState from "@store/Framework/Store/Starter/Pages/AccountSettings/AccountSettingsState";
import { Draft } from "immer";

const initialState: AccountSettingsState = {};

const actions = {
    "Pages/AccountSettings/SetInitialValues": (
        draft: Draft<AccountSettingsState>,
        action: { defaultBillToId?: string },
    ) => {
        draft.initialBillToId = action.defaultBillToId;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type AccountSettingsActions = Parameters<typeof reducer>[1];
export default reducer;
